import { cn } from "@/lib/utils";

interface CountBadgeProps {
  count: number;
  /** Accessible label, e.g. "3 unread notifications". */
  label?: string;
  /** Cap the displayed number; larger shows `{max}+`. */
  max?: number;
  className?: string;
}

/**
 * Small numeric pill for navbar/menu counts. Renders nothing at 0 so callers
 * can drop it in unconditionally. Caps at `max` (default 99) → "99+".
 */
export function CountBadge({
  count,
  label,
  max = 99,
  className,
}: CountBadgeProps) {
  if (count <= 0) return null;
  const text = count > max ? `${max}+` : String(count);

  return (
    <span
      aria-label={label ?? `${count} unread`}
      className={cn(
        "inline-flex min-w-[1.25rem] items-center justify-center rounded-full bg-destructive px-1.5 py-0.5 text-[0.6875rem] font-semibold tabular-nums leading-none text-destructive-foreground",
        className,
      )}
    >
      {text}
    </span>
  );
}
